export default "__VITE_ASSET__C19cx$ni__"